// extracted by mini-css-extract-plugin
export var avatar = "_ql-3";
export var avatarContainer = "_ql-2";
export var avatarSpacer = "_ql-5";
export var avatarSpacerContainer = "_ql-4";
export var avatarStackContainer = "_ql-1";
export var bubble = "_ql-0";
export var remainderBubble = "_ql-6";